import { jsx as _jsx } from "react/jsx-runtime";
import { inputBase } from '../system/inputBase';
export function Textarea({ rows = 4, invalid, style, ref, ...rest }) {
    return (_jsx("textarea", { ref: ref, "data-lpignore": "true", "data-1p-ignore": "true", "data-bwignore": "true", "data-form-type": "other", rows: rows, style: {
            ...inputBase,
            resize: 'vertical',
            borderColor: invalid ? 'var(--destructive)' : 'var(--border-strong)',
            ...style,
        }, ...rest }));
}
//# sourceMappingURL=Textarea.js.map